import { Category } from '~/types/common';
import { TreeIcon, FlowerIcon, DonateIcon, PreplaningIcon, GriefSupportIcon, TributeBlanketIcon, CommunityEventIcon, } from '~/elements/Icons';
const getCommercialButton = (category) => {
    let icon;
    let label = null;
    switch (category) {
        case Category.flower:
            icon = FlowerIcon;
            label = 'Send Flowers';
            break;
        case Category.plantTree:
            icon = TreeIcon;
            label = 'Plant a Tree';
            break;
        case Category.griefSupport:
            icon = GriefSupportIcon;
            label = 'Get Grief Support';
            break;
        case Category.prePlanning:
            icon = PreplaningIcon;
            label = 'Pre-plan a Funeral';
            break;
        case Category.communityEvent:
            icon = CommunityEventIcon;
            label = 'Community Events';
            break;
        case Category.tributeBlanket:
            icon = TributeBlanketIcon;
            label = 'Buy Tribute Blanket';
            break;
        case Category.donation:
            icon = DonateIcon;
            label = 'Make a Donation';
            break;
        default:
            icon = FlowerIcon;
            label = 'Send Flowers';
            break;
    }
    return { icon, label };
};
export { getCommercialButton };
